import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()(() => {
    return {
        root: {
            cursor: 'pointer',
        },
    }
})

export default useStyles
